import { render, staticRenderFns } from "./addUpdateRank.vue?vue&type=template&id=1a9bc88c&scoped=true"
import script from "./addUpdateRank.vue?vue&type=script&lang=js"
export * from "./addUpdateRank.vue?vue&type=script&lang=js"
import style0 from "./addUpdateRank.vue?vue&type=style&index=0&id=1a9bc88c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9bc88c",
  null
  
)

export default component.exports